import React, { createContext } from "react";

// AccountContext kept for backward compatibility
// Auth is now fully managed by AWS Amplify
// No Cognito logic needed here anymore
const AccountContext = createContext();

const Account = (props) => {
  return (
    <AccountContext.Provider value={{}}>
      {props.children}
    </AccountContext.Provider>
  );
};

export { Account, AccountContext };